import Select from "../../common/Select";

export default {
  type: {
    label: 'User Type',
    placeholder: 'Add user type',
    system: {
      name: 'user_level_id',
      altName: 'user_level',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'type',
    rules: {
      title: 'Type field',
      required: true,
    }
  },
  username: {
    label: 'User Name',
    placeholder: 'Add user name',
    system: {
      name: 'username',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'username',
    rules: {
      title: 'User name field',
      required: true,
    }
  },
  firstname: {
    label: 'First Name',
    placeholder: 'Add first name',
    system: {
      name: 'firstname',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'firstname',
    rules: {
      title: 'Firs name field',
      required: true,
    }
  },
  lastname: {
    label: 'Last Name',
    placeholder: 'Add last name',
    system: {
      name: 'lastname',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'lastname',
    rules: {
      title: 'Last name field',
      required: true,
    }
  },
  password: {
    label: 'Password',
    placeholder: 'Add password',
    system: {
      name: 'password',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'password',
    rules: {
      title: 'Password field',
      required: true,
    }
  },
  email: {
    label: 'Email',
    placeholder: 'Add email',
    value: '',
    system: {
      name: 'email',
    },
    errors: [],
    type: 'email',
    name: 'email',
    rules: {
      title: 'Email field',
      required: true,
      email: true,
    }
  },
  employee: {
    label: 'Employee',
    placeholder: 'Choose employee',
    value: null,
    system: {
      name: 'employee_id',
    },
    errors: [],
    type: 'select',
    name: 'employee_id',
    rules: {
      title: 'Email field',
      required: true,
    }
  },
  phone: {
    label: 'Phone',
    placeholder: 'Add phone',
    system: {
      name: 'phone',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'phone',
    rules: {
      title: 'Phone field',
    }
  },
  status: {
    label: 'User Status',
    placeholder: 'Status',
    system: {
      name: 'status',
      altName: 'status',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'status',
    rules: {
      title: 'Select Status',
      required: true,
    }
  },
  signature: {
    label: 'Signature',
    placeholder: 'Add signature',
    system: {
      name: 'signature',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'signature',
    rules: {
      title: 'Signature field'
    }
  },
  photoThumb: {
    label: "Photo",
    value: '',
    system: {
      name: 'photoThumb',
    },
    name: 'photoThumb'
  },
  customers: []
};


export const customers = {
  id: 0,
  name: 'customers',
  _system: {
    name: 'Customers',
    relatedTo: 'customers',
  },
  system: {
    name: 'customers',
  },
  customers_id: {
    system: {
      name: 'project_id',
      component: Select,
      relatedTo: 'customers',
    },
    name: 'id',
    value: '',
    rules: {},
  },

  user_id: {
    name: 'user_id',
    system: {
      name: 'user_id',
      relatedTo: 'customers',
    },
    value: '',
  },
  relation_id: {
    name: 'relation_id',
    system: {
      name: 'relation_id',
      relatedTo: 'customers',
    },
    value: '',
  }
};



// WEBPACK FOOTER //
// ./src/containers/PeopleEdit/fields.js